<template>
<div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="input-group search-holder">
                <input type="text" placeholder="Search by name, email or phone" @input="(e) => (bsTerm = e.target.value)" @keyup.enter="performBs" :value="bsTerm" class="search form-control" />
                <svg v-if="bsTerm" @click="resetBs" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close">
                    <g>
                        <g>
                            <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                  L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                  c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                  l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                  L284.286,256.002z" />
                        </g>
                    </g>
                </svg>

                <div class="input-group-append">
                    <button class="btn btn-search" type="button" :disabled="!bsTerm" @click="performBs">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                            <g>
                                <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                           s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                           C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                           s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                            </g>
                        </svg>
                    </button>
                    <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                        <img src="@/assets/filter.svg" alt="" />
                    </button>
                </div>
            </div>
            <div class="row mt-4 mb-3">
                <div class="col-6">
                    <h1>Leads</h1>
                </div>
                <!-- <div class="col-6 text-right">
            <router-link class="add-link" :to="{name: 'NewLead'}">
              <img src="../assets/add.svg" alt="" class="mr-1 mb-1" />
              Add new</router-link>
          </div> -->
            </div>
            <div class="filterTabs">
                <!-- <span style="height: 0;display: block; visibility: hidden;">{{ statusesMaster }}</span> -->
                <div @click="getStatuses($event)" class="status-btn-section">
                    <div v-for="status in statusus" :key="status.id" class="status-btn" :class="{ active: status.id == statusIdValue }" :data-status="status.id" :data-status-name="status.name">
                        <span class="tab-icon tab-icon-default tab-image" :data-status="status.id" :data-status-name="status.name" :class="statusClass(status)"></span>
                        <span class="tab-text">
                            <template v-if="status.name !== 'Unassigned'">{{
                  status.name
                }}</template>
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
                </div>
                <router-link v-for="(lead, key) in leads" :key="`lead-${key}`" class="card" :to="{ name: 'Lead', params: { id: lead.uuid } }">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-8">
                                <span class="d-block title">{{ lead.name }}</span>
                                <span class="d-block sub-title" v-if="lead.assigned_to">
                                    <img src="../assets/user.svg" class="mr-1 mb-1" />
                                    {{ lead.assigned_to }}</span>
                                <span class="d-block location">{{ lead.enquiry }}</span>
                            </div>
                            <div class="col-4 text-right" v-if="lead.status_name">
                                <span class="label-status">{{ lead.status_name }}</span>
                                <span class="lead-no">{{ lead.lead_no }}</span>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'">
        </paginate>
        <!-- <div v-if="!isRecordsAvailable" style="text-align:center;padding-top:40px;">No records found</div> -->
    </div>
    <!-- Right Menu Sidebar -->
    <b-sidebar id="sidebar-right" ref="sidebar-right" title="Advance Search" bg-variant="white" backdrop right shadow fixed>
        <template v-slot="{ hide }">
            <div class="card card-form sidebar-form-card">
                <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
                    <b-form-group>
                        <b-form-input type="text" v-model="advancedFilter.name" placeholder="Name"></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input type="number" v-model="advancedFilter.phone" placeholder="Mobile Number" minlength="10"></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input type="email" v-model="advancedFilter.email" placeholder="Email Address"></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        <b-form-select v-model="advancedFilter.city_id" :options="updatedCityList" :name="cityList"></b-form-select>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input type="number" min="0" v-model="advancedFilter.budget_from" placeholder="Budget From" @input="updateValue"></b-form-input>
                        <div class="error" v-if="validateBudgetFrom">
                            Please enter less than 200 crores
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input type="number" min="0" v-model="advancedFilter.budget_upto" placeholder="Budget Upto" @input="updateValue"></b-form-input>
                        <div class="error" v-if="validateBudgetUpto">
                            Please enter less than 200 crores
                        </div>
                    </b-form-group>
                    <b-form-group class="btn-fixed">
                        <b-button variant="primary" type="submit" block @click="hide" :disabled="validateBudgetFrom || validateBudgetUpto">Search</b-button>
                        <b-button variant="primary-outline" block type="reset">Reset</b-button>
                    </b-form-group>
                </b-form>
            </div>
        </template>
    </b-sidebar>
</div>
</template>

<script>
import qs from "qs";
import {
    paramsFromQuery,
    prepareLeadSearchParams,
} from "@/assets/scripts/utility.js";

export default {
    name: "Home",
    data() {
        return {
            activeStatus: "new",
            leads: [],
            advSearchParams: [],
            totalLeads: 0,
            perPage: 0,
            total: 0,
            tabIndex: 0,
            bsTerm: this.$route.query.bs,
            advancedFilter: {
                name: null,
                phone: null,
                email: null,
                city_id: null,
                budget_from: null,
                budget_upto: null,
            },
            validateBudgetFrom: false,
            validateBudgetUpto: false,
            isFromAdvancedSearch: false,
            isFromStatusClick: false,
            statusIdValue: 1,
            statusus: [],
            updatedCityList: [],
            isFromBasicSearch: false,
            isRecordsAvailable: false,
        };
    },
    computed: {
        cityList() {
            let cities = this.$store.getters.cities;
            this.updatedCityList.push({
                value: null,
                text: "Select a City"
            });
            cities.map((city) => {
                this.updatedCityList.push({
                    value: city.id,
                    text: city.name
                });
            });
            console.log(cities, "cities");
            return this.$store.getters.cities;
        },
        // statusesMaster() {
        //   let statusData = this.$store.getters.statusesMaster;
        //   if(this.statusus.length==0) {
        //     this.statusus = statusData;
        //   }
        //   // if(sessionStorage.getItem("isFromAdvancedSearch")) {
        //   //   this.advancedFilter = sessionStorage.getItem("isFromAdvancedSearch");
        //   // }
        //   return statusData;
        // },
        totalPages() {
            if (this.total === 0 || this.perPage === 0) {
                return 0;
            } else {
                return Math.ceil(this.total / this.perPage);
            }
        },
        pageNo: {
            get() {
                let pageNo = this.$route.query.pageNo || 1;
                return parseInt(pageNo);
            },
            set() {
                true;
            },
        },
        pageStart() {
            if (this.total === 0) {
                return 0;
            }
            return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
        },
        pageEnd() {
            if (this.total === 0) {
                return 0;
            }
            return Math.min(this.total, this.pageNo * this.perPage);
        },
    },
    created() {
        this.selectStatus();
    },
    watch: {
      $route(to, from){
        this.selectStatus();
      }
    },
    methods: {
        updateValue() {
            if (this.advancedFilter.budget_from > 20000000) {
                this.validateBudgetFrom = true;
            } else {
                this.validateBudgetFrom = false;
            }
            if (this.advancedFilter.budget_upto > 20000000) {
                this.validateBudgetUpto = true;
            } else {
                this.validateBudgetUpto = false;
            }
            this.$forceUpdate();
        },
        getAllStatuses() {
            this.$axios
                .get("settings")
                .then((res) => {
                    this.statusus = res.data.statuses;
                    if (JSON.parse(localStorage.getItem("filter"))) {
                        this.advancedFilter = JSON.parse(localStorage.getItem("filter"));
                        this.statusIdValue = 0;
                        if (this.statusus[0].name == "new") {
                            this.statusus.unshift({
                                id: 0,
                                name: "All",
                            });
                            // this.selectedStatusName = "All";
                        }
                        this.AdvancedFilter();
                    }
                })
                .catch((err) => console.log(err.response));
        },
        getStatuses(event) {
            this.isFromBasicSearch = false;
            let newQ = {
                ...this.$route.query
            };
            delete newQ.bs;
            this.bsTerm = "";
            this.$router.replace({
                query: newQ
            });
            // let statusData = this.$store.getters.statusesMaster;
            let selectedStatusName = event.target.getAttribute("data-status-name");
            if (selectedStatusName !== "All") {
                localStorage.removeItem("filter");
            }
            // this.value = []
            if (this.statusus[0].name == "All" && selectedStatusName !== "All") {
                this.statusus.shift();
            }
            if (selectedStatusName !== "All") {
                localStorage.removeItem("filter");
                let allButtons = this.$el.querySelectorAll(".status-btn");
                allButtons.forEach((el) => {
                    el.firstChild.classList.remove("active");
                    el.classList.remove("active");
                });
                event.target.classList.add("active");
                this.statusIdValue = event.target.getAttribute("data-status");
                console.log(this.statusIdValue,"status Id value")
                sessionStorage.setItem("statusId", this.statusIdValue);
                this.goTo();
                this.loadData();
            }
        },
        goTo() {
            let newQ = {
                ...this.$route.query,
                status_id: this.statusIdValue
            };
            if (this.statusIdValue !== 0) {
                delete newQ["name"];
                delete newQ["email"];
                delete newQ["phone"];
                delete newQ["budget_from"];
                delete newQ["budget_upto"];
                delete newQ["city_id"];
                delete newQ["is_advanced_search"];
                this.advancedFilter = {
                    name: null,
                    phone: null,
                    email: null,
                    city_id: null,
                    budget_from: null,
                    budget_upto: null,
                };
                this.isFromStatusClick = true;
            } else {
                // this.isFromAdvancedSearch = true;
                // this.isFromStatusClick = false;
                if (
                    JSON.parse(localStorage.getItem("filter")) &&
                    this.statusus.length > 0
                ) {
                    this.advancedFilter = JSON.parse(localStorage.getItem("filter"));
                    newQ = {
                        ...this.$route.query,
                        ...this.advancedFilter
                    };
                    let allButtons = this.$el.querySelectorAll(".status-btn");
                    // this.statusIdValue = 0;
                    allButtons.forEach((el) => {
                        el.childNodes[0].classList.remove("active");
                        el.classList.remove("active");
                    });

                    if (this.statusus[0] ?.name == "new") {
                        this.statusus.unshift({
                            id: 0,
                            name: "All",
                        });
                    }
                    allButtons[0].classList.add("active");
                    // } else  {
                    //   this.statusIdValue = 1;
                    // }
                }
                delete newQ["status_id"];
                this.statusIdValue = 0;
            }
            delete newQ["pageNo"];
            this.$router.replace({
                query: newQ
            });
            this.isFromAdvancedSearch = false;
        },
        selectStatus() {
            let status = this.$route.query.status_id || 1;
            let sendable;
            this.activeStatus = `status-${status}`;
            sendable = status;
            this.loadData(sendable);
        },
        loadData() {
            let queryP = {};
            let searchParams = this.$route.query;
            // if(!localStorage.getItem('filter') && !isFromBasicSearch) {
            //   console.log(searchParams,"search params")
            //   delete searchParams.bs;
            // }
            if (localStorage.getItem("filter")) {
                searchParams = JSON.parse(localStorage.getItem("filter"));
                searchParams["pageNo"] = this.$route.query?.pageNo;
                delete searchParams["status_id"];
            }
            for (let key in searchParams) {
                queryP[key] = searchParams[key];
            }
            if (localStorage.getItem("filter")) {
                this.advancedFilter = JSON.parse(localStorage.getItem("filter"));
            }
            this.advSearchParams = queryP;
            if (
                this.$route.query.is_advanced_search == "true" ||
                JSON.parse(localStorage.getItem("filter"))
            ) {
                this.advSearchParams["is_advanced_search"] = true;
                paramsFromQuery(queryP, this.advSearchParams, null);
            } else {
                paramsFromQuery(queryP, this.$route.query, this.statusIdValue);
            }
            this.$axios
                .get("leads", {
                    params: queryP,
                    paramsSerializer: (params) =>
                        qs.stringify(params, {
                            arrayFormat: "brackets"
                        }),
                })
                .then((res) => {
                    this.leads = res.data.leads;
                    if (this.leads.length > 0) {
                        this.isRecordsAvailable = true;
                    }
                    this.perPage = res.data.per_page;
                    this.total = res.data.count;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        goToPage(pageNo) {
            let newQ = {
                ...this.$route.query,
                pageNo
            };
            this.$router.replace({
                query: newQ
            });
        },
        AdvancedFilter() {
            let statusId = null;
            // if(this.$route.query.status_id) {
            //   this.statusId = this.$route.query.status_id;
            // }
            // if(localStorage.getItem('filter')) {
            // this.advancedFilter = JSON.parse(localStorage.getItem('filter'));
            // }
            this.statusIdValue = 0;
            let searchParams = prepareLeadSearchParams(this.advancedFilter, null);
            let newQ = {
                ...searchParams,
                is_advanced_search: true
            };
            delete newQ["status_id"];
            this.$router.replace({
                query: newQ
            });
            if (this.statusus[0].name == "new") {
                this.statusus.unshift({
                    id: 0,
                    name: "All",
                });
            }
            localStorage.setItem("filter", JSON.stringify(this.advancedFilter));
            this.goTo();
            this.loadData();
        },
        resetAdvancedFilter() {
            this.advancedFilter = {
                name: null,
                phone: null,
                email: null,
                city_id: null,
                budget_from: null,
                budget_upto: null,
            };
            localStorage.removeItem("filter");
            this.statusIdValue = 1;
            // advancedFilter["city_id"] = null;
            // this.goTo()
            // this.loadData();
            if (this.statusus[0].name == "All") {
                this.statusus.shift();
            }
            let rQ = this.$route.query;
            if (rQ.is_advanced_search) {
                this.$router.replace({
                    query: {
                        status_id: this.$route.query.status_id
                    },
                });
            }
        },
        resetBs() {
            let rQ = this.$route.query;
            this.bsTerm = "";
            if (rQ.bs) {
                let {
                    bs,
                    ...newQ
                } = rQ;
                this.$router.replace({
                    query: newQ
                });
            }
        },
        performBs() {
            if (this.bsTerm) {
                this.isFromBasicSearch = true;
                let newQ = {
                    ...this.$route.query,
                    bs: this.bsTerm
                };
                delete newQ.pageNo;
                this.$router.replace({
                    query: newQ
                });
                this.goTo();
                this.loadData();
            }
        },
        statusClass(status) {
            if (status.name) {
                return status.name.replace(/[^A-Z0-9]/gi, "");
            }
        },
    },
    mounted() {
        this.getAllStatuses();
        if(sessionStorage.getItem("statusId")) {
          this.statusIdValue = sessionStorage.getItem("statusId")
        }
        if (!JSON.parse(localStorage.getItem("filter"))) {
            this.goTo();
            this.loadData();
        }
    },
};
</script>

<style scoped>
.tab-text {
    font-size: 14px;
    text-align: center;
}

.status-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.status-btn-section::-webkit-scrollbar {
    width: 0;
    /* Remove scrollbar space */
    background: transparent;
    /* Optional: just make scrollbar invisible */
}

.tab-image {
    margin-right: 0;
}

.status-btn-section {
    display: flex;
    flex-direction: row;
    gap: 10px;
    /* flex-wrap: wrap; */
    overflow: scroll;
}

.buttn {
    border-radius: 20px;
    color: #bfbfbf;
    font-size: 13px;
    font-family: "qregular";
    white-space: nowrap;
    padding: 5px 14px;
    border-color: transparent !important;
}

.buttn.active {
    color: #fff;
    background-color: #2f80ed !important;
}

.btn-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 10px 20px;
    background: #fff;
    margin: 0;
}

.sidebar-form-card {
    padding: 20px 20px 100px;
}
</style>
